<div>
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <mat-dialog-content>
    <p>{{ data.prompt }}</p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <span style="flex: 1 0 auto;"></span>
    <button mat-button [mat-dialog-close]="{confirmed: false}">{{ cancelLabel }}</button>
    <button mat-button color="primary" [mat-dialog-close]="{confirmed: true}">{{ confirmLabel }}</button>
  </mat-dialog-actions>
</div>
